var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardShapeWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 110,
    viewBox: "0 0 181 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_202_1567",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 181,
    height: 110
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 181,
    height: 110,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_202_1567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.74204 110.225C6.53027 110.226 4.30551 109.301 2.61443 107.612C0.410666 105.411 -0.491146 102.301 0.260617 99.4975L104.907 -290.67C105.293 -292.114 106.059 -293.438 107.121 -294.499C108.183 -295.559 109.509 -296.325 110.954 -296.712C113.897 -297.497 117.064 -296.65 119.217 -294.499L405.113 -8.87823C407.268 -6.72556 408.117 -3.56199 407.328 -0.622803C406.939 0.824303 406.173 2.14849 405.113 3.20734C404.055 4.26518 402.729 5.0297 401.282 5.41846L10.7377 109.965C10.084 110.14 9.41327 110.225 8.74204 110.225ZM113.159 -294.954C112.6 -294.954 112.037 -294.882 111.485 -294.735C110.385 -294.441 109.378 -293.859 108.57 -293.052C107.761 -292.245 107.18 -291.238 106.886 -290.141L20.6777 83.6532C20.115 85.7529 20.8137 88.1045 22.5013 89.7914C24.1894 91.4784 26.5432 92.177 28.6459 91.6143L400.75 3.44168C401.851 3.14637 402.859 2.56473 403.664 1.76022C404.471 0.954719 405.053 -0.0526582 405.349 -1.15298C405.949 -3.3881 405.303 -5.79363 403.664 -7.43112L117.769 -293.052C116.535 -294.284 114.865 -294.954 113.159 -294.954Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardShapeWhite);
export default __webpack_public_path__ + "static/media/card-shape-white.4458eb9587bfa4116676b12230618300.svg";
export { ForwardRef as ReactComponent };